import template from "./configuration-update.html";
import controller from "./configuration-update.controller";
import "./configuration-update.scss";

const ConfigurationUpdateComponent = {
    template,
    controller,
    controllerAs: "ctrl"
};

export default ConfigurationUpdateComponent;


// WEBPACK FOOTER //
// ./sources/components/configurations/configuration-update/configuration-update.component.js